<template>
  <div class="main-container">
    <!-- 标题 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>升级订单列表</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="addUpgradeHandle()"
        >添加升级</el-button>
      </div>
      
      <!-- 搜索工具栏 -->
      <el-form :inline="true" :model="searchForm" class="form-container">
        <el-form-item label="预约ID">
          <el-input v-model="searchForm.appointmentId" placeholder="预约ID" clearable></el-input>
        </el-form-item>
        <el-form-item label="升级类型">
          <el-input v-model="searchForm.upgradeType" placeholder="升级类型" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
            <el-option label="申请中" value="申请中"></el-option>
            <el-option label="已批准" value="已批准"></el-option>
            <el-option label="已拒绝" value="已拒绝"></el-option>
            <el-option label="已完成" value="已完成"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getDataList()">查询</el-button>
          <el-button @click="resetSearch()">重置</el-button>
        </el-form-item>
      </el-form>
      
      <!-- 数据表格 -->
      <el-table
        :data="dataList"
        border
        v-loading="dataListLoading"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="id"
          header-align="center"
          align="center"
          width="100"
          label="ID"
        ></el-table-column>
        <el-table-column
          prop="appointmentId"
          header-align="center"
          align="center"
          width="100"
          label="预约ID"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="viewAppointment(scope.row.appointmentId)">
              {{ scope.row.appointmentId }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="upgradeType"
          header-align="center"
          align="center"
          label="升级类型"
        ></el-table-column>
        <el-table-column
          prop="upgradeDetails"
          header-align="center"
          align="center"
          label="升级详情"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="additionalCost"
          header-align="center"
          align="center"
          label="附加费用"
        >
          <template slot-scope="scope">
            {{ scope.row.additionalCost }} 元
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          header-align="center"
          align="center"
          width="100"
          label="状态"
        >
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="upgradeTime"
          header-align="center"
          align="center"
          width="180"
          label="创建时间"
        >
          <template slot-scope="scope">
            {{ scope.row.upgradeTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          header-align="center"
          align="center"
          width="200"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === '申请中'" type="text" size="small" @click="updateStatusHandle(scope.row.id, '已批准')">批准</el-button>
            <el-button v-if="scope.row.status === '申请中'" type="text" size="small" @click="updateStatusHandle(scope.row.id, '已拒绝')">拒绝</el-button>
            <el-button v-if="scope.row.status === '已批准'" type="text" size="small" @click="updateStatusHandle(scope.row.id, '已完成')">完成</el-button>
            <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" style="color: #F56C6C">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页控件 -->
      <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </el-card>
    
    <!-- 预约详情对话框 -->
    <el-dialog
      title="预约详情"
      :visible.sync="appointmentDialogVisible"
      width="700px"
    >
      <div v-if="appointmentDetail">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="预约ID">{{ appointmentDetail.id }}</el-descriptions-item>
          <el-descriptions-item label="教练编号">{{ appointmentDetail.jiaolianbianhao }}</el-descriptions-item>
          <el-descriptions-item label="教练姓名">{{ appointmentDetail.jiaolianxingming }}</el-descriptions-item>
          <el-descriptions-item label="用户账号">{{ appointmentDetail.zhanghao }}</el-descriptions-item>
          <el-descriptions-item label="用户姓名">{{ appointmentDetail.xingming }}</el-descriptions-item>
          <el-descriptions-item label="手机号码">{{ appointmentDetail.shouji }}</el-descriptions-item>
          <el-descriptions-item label="预约时间" :span="2">{{ appointmentDetail.yuyueshijian | formatDate }}</el-descriptions-item>
          <el-descriptions-item label="预约说明" :span="2">{{ appointmentDetail.yuyueshuoming }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag :type="getStatusType(appointmentDetail.status)">{{ appointmentDetail.status }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="审核状态">{{ appointmentDetail.sfsh }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="appointmentDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { formatDate } from '@/utils/date.js'

export default {
  filters: {
    formatDate(time) {
      if (time) {
        return formatDate(new Date(time), 'yyyy-MM-dd HH:mm:ss')
      }
      return ''
    }
  },
  data() {
    return {
      searchForm: {
        appointmentId: '',
        upgradeType: '',
        status: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      appointmentDialogVisible: false,
      appointmentDetail: null
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      this.$http({
        url: '/jiaolianyuyue/upgrade/page',
        method: 'get',
        // params: {
        //   page: this.pageIndex,
        //   limit: this.pageSize,
        //   appointmentId: this.searchForm.appointmentId,
        //   upgradeType: this.searchForm.upgradeType,
        //   status: this.searchForm.status
        // }
      }).then(({ data }) => {
        console.log("upgradeList",data);
        
        if (data && data.code === 0) {
          this.dataList = data.page.list
          this.totalPage = data.page.totalCount
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 跳转到添加升级页面
    addUpgradeHandle() {
      this.$router.push({ name: 'upgrade-add' })
    },
    // 查看预约详情
    viewAppointment(appointmentId) {
      this.$http({
        url: `/jiaolianyuyue/info/${appointmentId}`,
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.appointmentDetail = data.data
          this.appointmentDialogVisible = true
        } else {
          this.$message.error('获取预约详情失败')
        }
      }).catch(() => {
        this.$message.error('获取预约详情失败')
      })
    },
    // 更新升级状态
    updateStatusHandle(id, status) {
      this.$confirm(`确认将此升级记录状态修改为"${status}"吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: '/jiaolianyuyue/upgrade/updateStatus',
          method: 'post',
          params: {
            id: id,
            status: status
          }
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    // 删除
    deleteHandle(id) {
      this.$confirm('确定删除该升级记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: `/jiaolianyuyue/upgrade/delete/${id}`,
          method: 'post'
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    // 重置搜索条件
    resetSearch() {
      this.searchForm = {
        appointmentId: '',
        upgradeType: '',
        status: ''
      }
      this.getDataList()
    },
    // 根据状态获取样式类型
    getStatusType(status) {
      switch (status) {
        case '申请中': return 'warning'
        case '已批准': return 'success'
        case '已拒绝': return 'danger'
        case '已完成': return 'primary'
        default: return 'info'
      }
    }
  }
}
</script>

<style scoped>
.main-container {
  padding: 20px;
}
.form-container {
  margin-bottom: 20px;
}
</style> 